import { render, staticRenderFns } from "./full-version.vue?vue&type=template&id=25da12a8&"
import script from "./full-version.vue?vue&type=script&lang=js&"
export * from "./full-version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/full-version.vue
// module id = 1642
// module chunks = 0